<template>
  <div class="progress-bar">
    <span class="progress-bar-fill" :style="{width: barWIdth}"></span>
  </div>
</template>

<script>
export default {
  props: ["currentVal", "maxVal"],
  computed: {
    barWIdth() {
      return (this.currentVal / this.maxVal) * 100 + "%";
    },
  },
};
</script>

<style scoped>
.progress-bar {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #2e2e2e;
}

.progress-bar-fill {
  display: block;
  height: 10px;
  background-color: #3fa9f5;
  transition: width 0.5s ease-in-out;
}
</style>